import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  DEFAULT_LOCALE,
  getLocaleFromPath,
  isSupportedLocale,
  stripLocaleFromPath,
  withLocale,
} from "../../config/locales";

const useLangNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();

  const langNavigate = (to, language, state) => {
    // Prefer i18n.language (reflects user's selected language) over URL segment,
    // fall back to URL, then DEFAULT_LOCALE.
    const currentLocale = isSupportedLocale(i18n.language)
      ? i18n.language
      : getLocaleFromPath(location.pathname) ?? DEFAULT_LOCALE;

    const targetLocale = isSupportedLocale(language) ? language : currentLocale;
    const subpath = to
      ? to.startsWith("/")
        ? to
        : `/${to}`
      : stripLocaleFromPath(location.pathname);

    navigate(withLocale(targetLocale, subpath), state);
  };

  return langNavigate;
};

export default useLangNavigate;
